import { Component, Input, ViewChild, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener} from '@angular/core';
import { Faq } from '../../shared/types/FaqDto';

@Component({
  selector: 'lp2-faq-element',
  templateUrl: './faq-element.component.html',
  styleUrls: ['./faq-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqElement implements AfterViewInit{
  @Input() faq: Faq;
  @ViewChild('faqAnswer') faqAnswer: any;

  @HostListener('window:resize', ['$event'])
  resizeEvent() {
    this.evaluateShowToggleBtn();
  }

  showFullResponse = false;
  showToggleBtn =  false;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.evaluateShowToggleBtn();
    this.cd.detectChanges();
  }

  toggleShowFullResponse() {
    this.showFullResponse = !this.showFullResponse;
  }

  evaluateShowToggleBtn() {
    if (this.faqAnswer.nativeElement.scrollHeight - this.faqAnswer.nativeElement.clientHeight > 0) {
      this.showToggleBtn = true;
    } else {
      this.showToggleBtn = false;
    };
  }
}



// WEBPACK FOOTER //
// ./ts/app/faq/faq-element/faq-element.component.ts